import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, Button, FormHelperText } from "@material-ui/core";
import {
  OutlinedInput,
  ListItemText,
  TextField,
  Select,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import { useSelector } from "react-redux";
import * as env from "../utils/EnvVars";
import TopicName from "../components/TopicName";
import KeywordName from "../components/KeywordName";
import GradeName from "../components/GradeName";
import DifficultyName from "../components/DifficultyName";
import ExamType from "../components/ExamType";
import Country from "../components/Country";
import Tags from "../components/Tags";
import Language from "../components/Language";
import Preview from "../components/Preview";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical = "top",
  horizontal = "center";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const QuestionTF = React.forwardRef((props, ref) => {
  console.log(ref, "MCref");
  console.log(props.dataObj, "propssss");
  console.log(props.updatedList, "updatedList");
  console.log(props.dataObj,"props.dataObj")
  const userObj = useSelector((state) => state.userDetails);
  const [open, setOpen] = useState(false);
  const [severityAlert, setSeverityAlert] = useState("error");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);

  const TrueFalseArray = ["T", "F"];
  const alphaArr = ["A", "B"];

  const [shuffle, setShuffle] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  const [questionTypeId, setQuestionTypeId] = React.useState(11);
  const [questionTypeName, setQuestionTypeName] = React.useState("True False");
  const [questionBody, setQuestionBody] = React.useState("");
  const [correctAnswer, setCorrectAnswer] = React.useState("");
  const [explanation, setExplanation] = React.useState("");
  // Bottom Dropdowns
  const [topicList, setTopicList] = useState([]);
  const [topicId, setTopicId] = useState(0);
  const [topicName, setTopicName] = useState("");
  const [examType, setExamType] = useState("");
  const [gradeList, setGradeList] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeId, setGradeId] = useState(0);
  const [difficultyList, setDifficultyList] = useState([]);
  const [difficultyName, setDifficultyName] = useState("");
  const [difficultyId, setDifficultyId] = useState(0);
  const [languageList, setLanguageList] = useState([]);
  const [languageName, setLanguageName] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState("");
  const [tags, setTags] = useState([]);
  const [keyword, setKeyword] = useState([]);
  const [formattedKeyword, setFormattedKeyword] = useState("");
  const [formattedTags, setFormattedTags] = useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert() {
    setShowAlert(false);
  }

  const handleTopicChange = (selectedTopic) => {
    if (selectedTopic === null) {
      setTopicId(0);
      setTopicName("");
    }
    setTopicId(selectedTopic?.topicId || 0);
    setTopicName(selectedTopic?.topicName || "");
  };

  const handleGrade = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  };

  const handleDifficulty = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    console.log(valArr);
    setDifficultyId(valArr[0]);
    setDifficultyName(valArr[1]);
  };

  const handleLanguageChange = (event) => {
    setLanguageName(event.target.value);
  };

  const handleCountryChange = (event) => {
    setCountryName(event.target.value);
  };

  const handleExamTypeChange = (event) => {
    setExamType(event.target.value);
  };

  const handleTagChange = (event, selectedTags) => {
    setTags(selectedTags);
    setFormattedTags(selectedTags.join(","));
  };

  const handleKeywordChange = (event, selectedTags) => {
    setKeyword(selectedTags);
    setFormattedKeyword(selectedTags.join(","));
  };

  function handleAnswerOption(i, event) {
    const { value } = event.target;
    setRows((prev) => {
      const updateState = [...prev];
      updateState[i] = {
        ...updateState[i],
        responseId: TrueFalseArray[i],
        responseText: value,
      };
      return updateState;
    });
  }

  function createOption(opt) {
    const rowsInput = {
      responseId: "",
      responseText: "",
    };
    let optArr = [];
    if (opt === 11) {
      for (let i = 0; i < 2; i++) {
        optArr.push(rowsInput);
      }
    }
    setRows(optArr);
  }

  React.useEffect(() => {
    setRows([]);
    // if (open && userObj) {
    //   createOption(1);
    //   getApiData();
    // }
    if (open) {
      createOption(11);
      getData();
      // getApiData();
    }

    if (open && props.dataObj && props.dataObj.autoId) {
      setQuestionBody(props.dataObj.questionBankSet.questionBody);
      setGradeName(props.dataObj.gradeName);
      setExplanation(props.dataObj.questionBankSet.explanations);
      const responseChoices = props.dataObj.questionBankSet.responseChoice.map(
        (choice) => {
          return {
            responseId: choice.responseId, // Assuming you want to assign an ID to each response option
            responseText: choice.responseText,
          };
        }
      );
      setRows(responseChoices);
      setCorrectAnswer(props.dataObj.questionBankSet.correctResponse);
      setTopicId(props.dataObj.topicId);
      setTopicName(props.dataObj.topicName);
      const keywordsArray = props.dataObj.keywordNames
        .split(",")
        .filter((keyword) => keyword.trim() !== "");
      setKeyword(keywordsArray);
      setFormattedKeyword(props.dataObj.keywordNames);
      setGradeId(props.dataObj.gradeId);
      setGradeName(props.dataObj.gradeName);
      setDifficultyId(props.dataObj.difficultyId);
      setDifficultyName(props.dataObj.difficultyName);
      setExamType(props.dataObj.examType);
      setLanguageName(props.dataObj.language);
      setCountryName(props.dataObj.country);
      const TagsArray = props.dataObj.tags
        .split(",")
        .filter((tag) => tag.trim() !== "");
      setTags(TagsArray);
      setFormattedTags(props.dataObj.tags);
      setShuffle(
        props.dataObj.questionBankSet.responseChoiceShuffle === "Yes"
          ? true
          : false
      );
      // setTemplateTitle(props.dataObj.templateTitle);
    } else {
      setQuestionTypeId(11);
      setQuestionBody("");
      setCorrectAnswer("");
      setExamType("");
      setExplanation("");
      //   setRows([]);
      setTopicId(0);
      setTopicName("");
      setKeyword([]);
      setGradeId(0);
      setGradeName("");
      setDifficultyId(0);
      setDifficultyName("");
      setLanguageName("");
      setCountryName("");
      setTags([]);
      setShuffle(false);
    }
  }, [props.dataObj, open]);

  const getData = async () => {
    try {
      let endpoint1 = env.API_KEY + "/topics-list";
      let endpoint2 = env.API_KEY + "/languages-list";
      let endpoint3 = env.API_KEY + "/country-list";
      let endpoint4 = env.API_KEY + "/difficulty-list";
      let endpoint5 = env.API_KEY + "/grades-list";

      const axiosrequest1 = axios.get(endpoint1);
      const axiosrequest2 = axios.get(endpoint2);
      const axiosrequest3 = axios.get(endpoint3);
      const axiosrequest4 = axios.get(endpoint4);
      const axiosrequest5 = axios.get(endpoint5);

      let [response1, response2, response3, response4, response5] =
        await axios.all([
          axiosrequest1,
          axiosrequest2,
          axiosrequest3,
          axiosrequest4,
          axiosrequest5,
        ]);
      setTopicList(response1?.data?.obj);
      setLanguageList(response2?.data?.obj);
      setCountryList(response3?.data?.obj);
      setDifficultyList(response4?.data?.obj);
      setGradeList(response5?.data?.obj);
    } catch (error) {
      console.log("error");
    }
  };

  async function getApiData() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: userObj.loginId,
        token: userObj.token,
        device: "web",
      },
    };
    let endpoints1 =
      env.API_EXAM_SERVICE +
      "/topic-service/read/topics-templates?sortby=templateName&maxRows=50000";
    let endpoints2 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints3 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints4 =
      env.API_EXAM_SERVICE +
      "/exams/read/exam-limits-templates?sortby=templateTitle&maxRows=50000";
    let endpoints5 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints6 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints7 =
      env.API_EXAM_SERVICE +
      "/exams/read/mocktest-templates?sortby=templateTitle&maxRows=50000";
    let endpoints8 =
      env.API_EXAM_SERVICE +
      "/exams/read/topictest-templates?sortby=templateTitle&maxRows=50000";

    const axiosrequest1 = axios.get(endpoints1, axiosHeader);
    const axiosrequest2 = axios.get(endpoints2, axiosHeader);
    const axiosrequest3 = axios.get(endpoints3, axiosHeader);
    const axiosrequest4 = axios.get(endpoints4, axiosHeader);
    const axiosrequest5 = axios.get(endpoints5, axiosHeader);
    const axiosrequest6 = axios.get(endpoints6, axiosHeader);
    const axiosrequest7 = axios.get(endpoints7, axiosHeader);
    const axiosrequest8 = axios.get(endpoints8, axiosHeader);

    await axios
      .all([
        axiosrequest1,
        axiosrequest2,
        axiosrequest3,
        axiosrequest4,
        axiosrequest5,
        axiosrequest6,
        axiosrequest7,
        axiosrequest8,
      ])
      .then(
        axios.spread(function (res1, res2, res3, res4, res5, res6, res7, res8) {
          // setTreeviewTemplateList(res1.data.list);
          // setSelftestOptionsObjectiveList(res2.data.list);
          // setSelftestOptionsSubjectiveList(res3.data.list);
          // setExamLimitList(res4.data.list);
          // setObjectiveQueTypeTempList(res5.data.list);
          // setSubjectiveQueTypeTempList(res6.data.list);
          // setMocktestTemplateList(res7.data.list);
          // setTopictestTemplateList(res8.data.list);
        })
      );
  }


  let questionJson = {
    questionType: "True False",
    commonDataDescription: null,
    questionBody: questionBody,
    columns: null,
    responseChoiceShuffle: shuffle ? "Yes" : "No",
    responseChoice: rows?.map((el) => {
      let obj = {};
      obj.responseId = el.responseId;
      obj.responseText = el.responseText;
      return obj;
    }),
    correctResponse: correctAnswer,
    explanations: explanation,
  };

  function handleSave() {
    // Check if questionBody is not empty
    if (!questionBody) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter Question");
      return false;
    } else if (!topicName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Topic");
      return false;
    } else if (!gradeName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Grade Name");
      return false;
    } else if (!examType) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Exam Type");
      return false;
    } else if (!languageName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select language");
      return false;
    }

    // Check if questionBody has content
    if (
      questionBody &&
      questionBody.length > 1 &&
      topicName &&
      gradeName &&
      examType &&
      languageName
    ) {
      setSaveLoading(true);

      // Create FormData object
      const data = new FormData();

      // Append data to FormData object
      if (props.dataObj && props.dataObj.autoId) {
        // If props.dataObj.autoId exists, it means we are updating an existing question
        data.append("id", props.dataObj.autoId);
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", "True False");
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
        // Append the ID of the question being updated
      } else {
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", "True False");
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      }

      // Determine the API endpoint based on whether it's a new question or an update
      let apiURL = "/admin-questionbanks-create";
      let myMessage = "Question has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/admin-questionbanks-update";
        myMessage = "Question has been updated.";
      }

      // Send POST request to the API endpoint
      axios
        .post(env.API_KEY + apiURL, data, {
          headers: {
            "Content-Type": "multipart/mixed",
            // Include any additional headers if needed
          },
        })
        .then((response) => {
          setSaveLoading(false);
          props.updatedList(response);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            window.location.reload();
            // props.updatedList(response.data.list);
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
          setSaveLoading(false); // Set loading to false in case of error
        });
    }
  }

  //   function handleQuestionType(val) {
  //     setQuestionTypeId(val);
  //     createOption(val);
  //   }

  return (
    <>
      <Dialog
        disableEnforceFocus
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <DialogContent>
          <Box style={{ display: "flex" }}>
            <Grid item md={6} xs={6} className="test-instructions">
              <div className="btmbdrgry">
                <h3>{props.dataObj != null ? <>Edit</> : <>New</>} Question</h3>
              </div>
              <p>
                <table
                  style={{ width: "100%" }}
                  cellSpacing="1"
                  cellPadding="8"
                >
                  <tr>
                    <td>
                      <TextField
                        label="Question Body"
                        onChange={(event) =>
                          setQuestionBody(event.target.value)
                        }
                        value={questionBody}
                        sx={{ fontSize: 10 }}
                        rows={3}
                        multiline
                        size="small"
                        variant="outlined"
                        fullWidth
                      />
                      {/* {JSON.stringify(rows)} */}
                    </td>
                  </tr>
                  {rows && rows.length > 0
                    ? rows.map((row, index) => (
                        <tr>
                          <td>
                            <TextField
                              label="Option"
                              value={row?.responseText}
                              onChange={(event) =>
                                handleAnswerOption(index, event)
                              }
                              sx={{ fontSize: 10 }}
                              size="small"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <div>{alphaArr[index]}</div>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    : null}
                  <tr>
                    <td>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={shuffle}
                            onChange={(event) =>
                              setShuffle(event.target.checked)
                            }
                          />
                        }
                        label="Option Shuffle"
                        style={{ marginTop: -14, marginBottom: -14 }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          Correct Answer
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={correctAnswer}
                          label="Correct Answer"
                          onChange={(event) =>
                            setCorrectAnswer(event.target.value)
                          }
                        >
                          {rows && rows.length > 0
                            ? rows.map((row, i) => (
                                <MenuItem value={TrueFalseArray[i]}>
                                  {TrueFalseArray[i]}
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextField
                        label="Explanation"
                        onChange={(event) => setExplanation(event.target.value)}
                        value={explanation}
                        sx={{ fontSize: 10 }}
                        rows={3}
                        multiline
                        size="small"
                        variant="outlined"
                        fullWidth
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TopicName
                        topicList={topicList}
                        handleTopicChange={handleTopicChange}
                        topicName={topicName}
                        topicId={topicId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <KeywordName
                        handleKeywordChange={handleKeywordChange}
                        keyword={keyword}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <GradeName
                        gradeName={gradeName}
                        handleGrade={handleGrade}
                        gradeList={gradeList}
                        gradeId={gradeId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <DifficultyName
                        difficultyName={difficultyName}
                        handleDifficulty={handleDifficulty}
                        difficultyList={difficultyList}
                        difficultyId={difficultyId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ExamType
                        examType={examType}
                        handleExamTypeChange={handleExamTypeChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Language
                        languageName={languageName}
                        handleLanguageChange={handleLanguageChange}
                        languageList={languageList}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Country
                        countryName={countryName}
                        handleCountryChange={handleCountryChange}
                        countryList={countryList}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Tags handleTagChange={handleTagChange} tag={tags} />
                    </td>
                  </tr>
                </table>
                <Box mt={2}>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                    style={{ marginRight: 12 }}
                    size="small"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  {saveLoading ? (
                    <LoadingButton
                      loading={saveLoading}
                      style={{
                        backgroundColor: "#008000",
                        color: "#FFF",
                        marginRight: 10,
                      }}
                      size="small"
                      variant="contained"
                    >
                      Save
                    </LoadingButton>
                  ) : (
                    <Button
                      // onClick={() => {
                      //   saveData();
                      // }}
                      onClick={() => handleSave()}
                      style={{
                        backgroundColor: "#008000",
                        color: "#FFF",
                        marginRight: 10,
                      }}
                      size="small"
                      variant="contained"
                    >
                      Save
                    </Button>
                  )}
                </Box>
              </p>
            </Grid>
            <Grid item md={6} xs={6} spacing={1}>
              <div>
                <div className="btmbdrgry">
                  <h2>Preview</h2>
                </div>
                <Box sx={{ marginTop: "20px" }}>
                  <h4>{questionBody ? "Q." + " " + questionBody : ""}</h4>
                  <ul style={{ listStyleType: "none", padding: 0 }}>
                    {rows?.map((el, i) => (
                      <li key={i}>
                        {el.responseText && (
                          <>
                            <Typography
                              component="span"
                              style={{ marginRight: "5px" }}
                            >
                              {alphaArr[i] + " ."}
                            </Typography>
                          </>
                        )}
                        {el.responseText}
                      </li>
                    ))}
                  </ul>
                  {correctAnswer && (
                    <Typography component="span">
                      <span><strong>Correct Answer :</strong></span>{" "}
                      {correctAnswer}
                    </Typography>
                  )}
                  <br />
                  {explanation && (
                    <Typography component="span">
                      <span><strong>Explanation :</strong></span>{" "}
                      {explanation}
                    </Typography>
                  )}
                </Box>
              </div>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={hideAlert}
            variant="filled"
            severity={severityAlert}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
});

export default QuestionTF;
